<!--
@Create By Tim For 19/08/16
@课件详情组件
-->
<template>
  <div class="CourseInfo">
    <div class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/AllCourse' }">在线课程</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'AllCourse', params: { category: navID } }">{{
            category
          }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ courseInfo.courseName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 头部课程详情模块 -->
    <div class="info">
      <!-- 左侧课程图片 -->
      <div class="infoImg">
        <el-image fit="fill" style="width:680px;height:300px;" :lazy="true"
                  :src="courseInfo.coursePicUrl">
          <div slot="placeholder" class="placeholder">封面加载中...</div>
        </el-image>
      </div>
      <!-- 右侧课程详情内容 -->
      <div class="infoContent">
        <h1>{{ courseInfo.courseName }}</h1>
        <div class="infoContentRage">
          <span>{{ examCount }}人学习</span>
          |
          <span>好评度 {{ positiveRating }}%</span>
        </div>
        <div class="infoContentFree">免费</div>
        <div class="infoContentLecturer" v-if="courseInfo.courseExam">
          <span>考试地址：<el-link type="primary" @click="openUrl(courseInfo.courseExam)">{{
              courseInfo.courseExam
            }} </el-link></span>
        </div>
        <el-button v-if="videoURL" class="playBtn" type="primary" @click="playerVideo">开始学习
        </el-button>
      </div>
    </div>
    <!-- 主体课程概述目录评论 -->
    <div class="mainBg">
      <div class="main">
        <!-- 左侧概述目录评论 -->
        <div class="courseTabs">
          <div class="courseTabsTitle">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="课程概述" name="overview">
                <CourseOverview :overview="courseInfo.courseDescription"
                                v-if="activeName == 'overview'"/>
              </el-tab-pane>
              <el-tab-pane label="目录" name="catalog">
                <CourseCatalog v-if="activeName == 'catalog'" :chapterList="chapterList"
                               @select="selectChapter"/>
              </el-tab-pane>
              <el-tab-pane label="评论" name="comment">
                <CourseComment v-if="activeName == 'comment'"/>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <!-- 右侧讲师信息 -->
        <div class="courseLecturer">
          <LecturerInfo/>
        </div>
        <div class="courseLecturer" v-if="docList && docList.length>0">
          <div style="font-size: 16px">文档列表</div>
          <div style="margin-top: 12px;">
            <ol>
              <li v-for="(item,key) in docList">
                <el-button type="text" @click="downloadData(item)">{{ item.docName }}</el-button>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频播放组件 v-if="videoURL!=''"-->
    <VideoPlayer v-if="open" ref="videoPlayer" :progress="progress" @time="endTime"
                 @ended="onPlayerEnded"/>
  </div>
</template>
<script>
import axios from 'axios'
import api from '../../../config/api'
import Bus from '../../bus'
import LecturerInfo from './LecturerInfo'
import CourseCatalog from './CourseCatalog'
import CourseOverview from './CourseOverview'
import CourseComment from './CourseComment'

import VideoPlayer from '../VideoPlayer'
import {getToken} from 'chaos-sso-util'

export default {
  name: 'CourseInfo',
  props: ['courseID'],
  data () {
    return {
      docList: undefined,
      // 播放器渲染
      open: false,
      // 视频进度条
      progress: true,
      // tab切换
      activeName: 'overview',
      // 课程详情集合
      courseInfo: [],
      // 课程章节集合
      chapterList: [],
      // 课程章节
      chapter: {},
      // 讲师
      employeeName: '',
      // 视频播放地址
      videoURL: '',
      // 分类ID
      navID: '',
      // 定时器名称
      timer: null,
      // 播放结束状态
      ended: 0,
      // 观看学习人数
      examCount: 0,
      // 好评
      positiveRating: 0
    }
  },

  computed: {
    category () {
      let nav = JSON.parse(window.sessionStorage.getItem('nav'))
      if (nav) {
        this.navID = nav.id
        return nav.label
      }
      return ''
    }
  },

  components: {
    LecturerInfo,
    CourseComment,
    CourseCatalog,
    CourseOverview,
    VideoPlayer
  },

  created () {
    this.getCount()
    this.getPositiveRating()
    this.getInfo()
    this.getData()
  },
  mounted () {
    // 在beforeDestroy钩子触发时清除定时器
    this.$once('hook:beforeDestroy', () => {
      clearInterval(this.timer)
    })
    this.getList()
  },
  methods: {
    createObjectURL(object) {
      return window.URL ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
    },

    downloadData (item) {
      var self = this
      var xhr = new XMLHttpRequest()
      var formData = new FormData()
      console.log('api--------->', api)
      xhr.open('get', api + 'portal/doc/download?id=' + item.id)
      //url填写后台的接口地址，如果是post，在formData append参数（参考原文地址）
      xhr.setRequestHeader(process.env.VUE_APP_SSO_HEADER_TOKEN, getToken())
      xhr.responseType = 'blob'
      xhr.onload = function (e) {
        if (this.status == 200) {
          console.log("self--------->",self)
          var blob = this.response
          var filename = item.docName
          // console.log(this.response)
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename)
          } else {
            var a = document.createElement('a')
            var url = self.createObjectURL(blob)
            a.href = url
            a.download = filename
            document.body.appendChild(a)
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }

      xhr.send(formData);
    },

    getList () {

      this.$axios({
        method: 'get',
        url: api + 'edu/doc/list/',
        params: {
          courseId: this.$route.params.id
        }
      }).then(res => {

        if (res && res.rows) {
          this.docList = res.rows
        }
      })

    }
    ,
    // tab切换
    handleClick (tab, event) {
    }
    ,
    // 查询课程详情
    getInfo () {
      this.$axios.get(api + 'portal/course/' + this.$route.params.id).then(res => {
        this.courseInfo = res
        if (res.prigress == 0) {
          this.progress = false
        } else {
          this.progress = true
        }
        // 播放器渲染
        this.open = true
        //this.employeeName = res.lecturer.employeeName;
      })
    }
    ,
    // 获取当前视频其他章节信息, 因为获取视频播放URL需要用到章节ID以及课程ID
    getData () {
      this.$axios.get(api + 'portal/chapter/list?courseId=' + this.$route.params.id).then(res => {
        if (res.length > 0) {
          // 取第一个章节下的章节id
          for (var i = 0; i < res.length > 0; i++) {
            if (res[i].children.length > 0) {
              this.chapter = res[i].children[0]
              this.videoURL = res[i].children[0].m3u8Url
              break
            }
          }
          this.chapterList = res
        }
      })
    }
    ,
    // 观看人数
    getCount () {
      this.$axios.get(api + 'portal/history/count/' + this.$route.params.id).then(res => {
        this.examCount = res
      })
    }
    ,
    // 好评率
    getPositiveRating () {
      this.$axios.get(api + 'portal/discuss/count?courseId=' + this.$route.params.id).then(res => {
        this.positiveRating = res.positiveRating
      })
    }
    ,
    openUrl (url) {
      window.open(url)
    }
    ,
    // 通过目录选择章节视频播放
    selectChapter (chapter) {
      this.chapter = chapter
      this.videoURL = chapter.m3u8Url
      this.playerVideo()
    }
    ,
    // 开始学习按钮点击
    playerVideo () {
      // 判断视频播放URL是否加载完成
      if (this.videoURL) {
        // 播放结束标志
        this.ended = 0
        // 调用视频播放弹窗内的打开弹窗方法
        this.$refs.videoPlayer.openVideoDialog(this.videoURL)
        // 开启定时器
        this.openTimer()
      }
    }
    ,
    openTimer () {
      // 先将上一个定时器关闭
      if (this.timer) {
        // 关闭定时器
        this.clearTimer()
      }
      // 开启新定时器
      this.timer = setInterval(() => {
        //播放時間记录
        let time = this.$refs.videoPlayer.getCurrentTime()
        if (time) {
          this.addPlayerTime(time)
        }
      }, 10000)
    }
    ,
    // 关闭定时器
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
    }
    ,
    // 视频关闭或播放完成
    endTime (time) {
      // 关闭定时器
      this.clearTimer()
      if (time) {
        this.addPlayerTime(time)
      }
    }
    ,
    // 播放结束
    onPlayerEnded (player) {
      //播放時間记录
      let time = this.$refs.videoPlayer.getCurrentTime()
      // 关闭定时器
      this.clearTimer()
      console.log('player ended!', player)
      this.ended = 1
      this.addPlayerTime(time)
      this.ended = 0
    }
    ,
    // 记录播放时间
    addPlayerTime (time) {
      //console.info(time)
      //console.info(this.chapter)
      let data = {
        videoId: this.chapter.videoId,
        chapterId: this.chapter.id,
        courseId: this.chapter.courseId,
        viewingTime: time,
        ended: this.ended
      }
      this.$axios.post(api + 'portal/history', data).then(res => {
      })
    }
  }
}
</script>
<style>
body {
  overflow-y: auto !important;
}

.CourseInfo .courseTabs .courseTabsTitle .el-tabs__nav-wrap::after {
  height: 0;
}

.CourseInfo .courseTabs .courseTabsTitle .el-tabs__active-bar {
  top: 0;
  height: 7px;
}

.CourseInfo .courseTabs .courseTabsTitle .el-tabs__item {
  font-size: 16px;
  height: 60px;
  line-height: 60px;
}
</style>
<style scoped>
.CourseInfo .title {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #000;
  width: 1440px;
  margin: 0 auto;
}

.CourseInfo .info {
  margin: 0 auto;
  width: 1440px;
  padding: 40px 0;
  border-top: 1px solid #d3d3d3;
  overflow: hidden;
}

.CourseInfo .infoImg {
  float: left;
  width: 680px;
  height: 300px;
  background: #ccc;
  margin-right: 50px;
  overflow: hidden;
}

.CourseInfo .infoImg img {
  width: 100%;
}

.CourseInfo .infoContent {
  float: left;
  width: 710px;
  height: 300px;
}

.CourseInfo .infoContent h1 {
  font-size: 26px;
  color: #000;
  font-weight: normal;
  margin-bottom: 20px;
}

.CourseInfo .infoContent .infoContentRage {
  font-size: 20px;
  color: #999;
  margin-bottom: 20px;
}

.CourseInfo .infoContent .infoContentFree {
  background: #f4f4f4;
  border-radius: 2px;
  font-size: 20px;
  color: #ff0101;
  height: 43px;
  line-height: 43px;
  margin-bottom: 20px;
  text-indent: 15px;
}

.CourseInfo .infoContent .infoContentLecturer {
  font-size: 20px;
  color: #666666;
  height: 25px;
  line-height: 25px;
  margin-bottom: 30px;
}

.CourseInfo .infoContent .infoContentLecturer span:nth-child(1) {
  margin-right: 80px;
}

.CourseInfo .infoContent .playBtn {
  width: 120px;
  height: 58px;
  font-size: 20px;
}

.CourseInfo .mainBg {
  padding: 30px 50px;
  margin: 0 auto;
  background: #f4f4f4;
}

.CourseInfo .main {
  width: 1440px;
  margin: 0 auto;
  overflow: hidden;
}

.CourseInfo .main .courseTabs {
  width: 1000px;
  background: #fff;
  float: left;
  min-height: 700px;
}

.CourseInfo .main .courseLecturer {
  float: right;
  width: 370px;
  padding: 20px;

  background: #fff;
  margin-bottom: 12px;
}

.CourseInfo .main .courseTabs .courseTabsTitle {
  padding: 0 20px;
}

.CourseInfo .placeholder {
  width: 221px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/CourseInfo/CourseInfo.vue